import { Source, Layer } from '@vis.gl/react-maplibre';
import type { IntersectionGeometry } from '../../types/intersection';

interface IntersectionLayersProps {
  geometry: IntersectionGeometry;
}

export function IntersectionLayers({ geometry }: IntersectionLayersProps) {
  const areaGeoJSON: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: [geometry.intersectionArea]
  };

  const lanesGeoJSON: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: geometry.lanes
  };

  const crosswalksGeoJSON: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: geometry.crosswalks
  };

  return (
    <>
      {/* Intersection area */}
      <Source id="intersection-area" type="geojson" data={areaGeoJSON}>
        <Layer
          id="intersection-area-fill"
          type="fill"
          paint={{
            'fill-color': '#1e293b',
            'fill-opacity': 0.6
          }}
        />
        <Layer
          id="intersection-area-outline"
          type="line"
          paint={{
            'line-color': '#475569',
            'line-width': 2,
            'line-dasharray': [4, 4]
          }}
        />
      </Source>

      {/* Lanes */}
      <Source id="lanes" type="geojson" data={lanesGeoJSON}>
        <Layer
          id="lanes-line"
          type="line"
          paint={{
            'line-color': '#94a3b8',
            'line-width': 1,
            'line-opacity': 0.5,
            'line-dasharray': [6, 4]
          }}
        />
      </Source>

      {/* Crosswalks */}
      <Source id="crosswalks" type="geojson" data={crosswalksGeoJSON}>
        <Layer
          id="crosswalks-fill"
          type="fill"
          paint={{
            'fill-color': '#e2e8f0',
            'fill-opacity': 0.3
          }}
        />
        <Layer
          id="crosswalks-outline"
          type="line"
          paint={{
            'line-color': '#ffffff',
            'line-width': 1,
            'line-opacity': 0.6
          }}
        />
      </Source>
    </>
  );
}
